<template>
  <img
    v-if="manufacturer.image || error"
    loading="lazy"
    class="provider__img"
    :src="image"
    :alt="manufacturer.name"
    @error="errorImage"
  />
</template>

<script>
import { BASE_URL } from 'src/common/config'
import { cdnDomain } from 'src/common/functions'

export default {
  props: {
    manufacturer: {
      type: Object,
      required: true,
    },
  },
  emits: ['toggle'],
  data() {
    return {
      BASE_URL: BASE_URL,
      error: false,
    }
  },
  computed: {
    image() {
      const rawUrl = this.manufacturer.image.startsWith('/')
        ? this.manufacturer.image.slice(1)
        : this.manufacturer.image
      return cdnDomain + rawUrl
    },
  },
  methods: {
    errorImage() {
      this.error = true
    },
  },
}
</script>

<style scoped lang="scss">
img {
  display: block;
  height: 100%;
  object-fit: contain;
  object-position: center;
  width: 100%;
  pointer-events: none;
}
</style>
